import React from 'react'
import { Navigate, Outlet, useSearchParams } from 'react-router-dom'
import { useAuth } from 'features/auth/store/authStore'

export default function RegistrationRoute() {
  const [searchParams] = useSearchParams()
  const { registrationToken, setRegistrationToken, setRole } = useAuth()

  const token = searchParams.get('token')
  const role = searchParams.get('role')

  if (token) {
    setRegistrationToken(token)
    setRole(role)
  }
  return registrationToken || token ? <Outlet /> : <Navigate to={'/'} />
}
